import { render, staticRenderFns } from "./brands-working-with.vue?vue&type=template&id=cedce8bc"
import script from "./brands-working-with.vue?vue&type=script&lang=js"
export * from "./brands-working-with.vue?vue&type=script&lang=js"
import style0 from "./brands-working-with.vue?vue&type=style&index=0&id=cedce8bc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cedce8bc')) {
      api.createRecord('cedce8bc', component.options)
    } else {
      api.reload('cedce8bc', component.options)
    }
    module.hot.accept("./brands-working-with.vue?vue&type=template&id=cedce8bc", function () {
      api.rerender('cedce8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/brands-working-with.vue"
export default component.exports